<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import {sgettext} from '../../../i18n.js';
    import {ISSUE_PAGE_SAVED_ROW_ID, ISSUE_PAGE_SAVED_PAGE_NUMBER} from '../../../constants.js'
    export let row;
    export let detail = false;
    export let isLinkedToNotification = false;
    export let isLink = true;


</script>

<style>
    .description-details {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
    }

    .description-details label {
        font-weight: bold;
    }
    .trim-improvement {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>

{#if !isLinkedToNotification}
    {#if isLink}
        <a href="{`${PATH_PREFIX}/sw/common/issues/${row.id}/`}"
           on:click={
            ()=>{
                sessionStorage.setItem(ISSUE_PAGE_SAVED_ROW_ID, row.id);
                sessionStorage.setItem(ISSUE_PAGE_SAVED_PAGE_NUMBER, row.page);
         }}>
        <div class="trim-improvement">
            {row.value}
        </div>
        </a>
    {:else}
        <strong>{row.value}</strong>
    {/if}

{:else if isLinkedToNotification && detail}
    <div class="description-details">
        <label>{sgettext('$$OCCURRED$$')}:</label>
        <div>{row.linked_issues[0].value}</div>
        <label>{sgettext('$$IMMED_ACTION_TAKEN$$')}:</label>
        <div>{row.linked_issues[0].action_taken ? row.linked_issues[0].action_taken : ''}</div>
        <label>{sgettext('$$WORK_REQUIREMENTS$$')}:</label>
        <div>{row.linked_issues[0].work_requirements ? row.linked_issues[0].work_requirements : ''}</div>
        <label>{sgettext('$$EQUIP_CONSTRAINTS$$')}:</label>
        <div>{row.linked_issues[0].equipment_restraints ? row.linked_issues[0].equipment_restraints : ''}</div>
        <label>{sgettext('$$INFORMATION_2$$')}:</label>
        <div>{row.linked_issues[0].extra_description ? row.linked_issues[0].extra_description : ''}</div>
    </div>
{/if}
